import React from 'react';
import ChevronIcon from '@shared/ui/icons/Chevron';
import { twMerge } from '@shared/utils/twMerge';
import { FC, ReactNode, useState } from 'react';

type BackButtonProps = {
  className?: string;
  text?: string;
  children?: ReactNode;
  action?: () => void;
};

export const BackButton: FC<BackButtonProps> = ({ action, text = 'Back' }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const iconColor = isHovered ? 'text-black' : 'text-spanishGray';
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  return (
    <div
      data-testid="backButton"
      className="border-pastelBlue box-content h-[20px] cursor-pointer overflow-hidden rounded-[4px] border"
      onClick={action}
      style={{
        minWidth: '20px',
        maxWidth: isHovered ? '110px' : '20px',
        transition: 'max-width .5s linear',
      }}
    >
      <div
        className={twMerge(
          'flex items-center items-center rounded-[4px] !bg-transparent !p-0 !text-black'
        )}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <ChevronIcon className={twMerge('ml-[.4rem] mr-1', iconColor)} />
        <span className="text-1420 mr-1">{text}</span>
      </div>
    </div>
  );
};
